module.exports = __webpack_public_path__ + "img/25072684000168.fee8a473.png";